import { motion } from "framer-motion";
import { GALLERY } from "../../lib/content";
import { MaskLine, SectionLabel } from "./Reveal";

const SPANS = [
  "lg:col-span-7 aspect-[16/10]",
  "lg:col-span-5 aspect-[16/10]",
  "lg:col-span-4 aspect-[4/5]",
  "lg:col-span-4 aspect-[4/5]",
  "lg:col-span-4 aspect-[4/5]",
  "lg:col-span-12 aspect-[16/6]",
];

export default function Gallery() {
  return (
    <section data-testid="gallery-section" className="bg-white py-24 lg:py-32 border-t border-ink/10">
      <div className="max-w-7xl mx-auto px-6">
        <SectionLabel>Gallery</SectionLabel>
        <h2 className="font-heading font-extrabold tracking-tight text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1] mb-14">
          <MaskLine>Inside our</MaskLine>
          <MaskLine delay={0.1}>classrooms<span className="text-flame">.</span></MaskLine>
        </h2>

        <div className="grid lg:grid-cols-12 gap-4">
          {GALLERY.map((src, i) => (
            <motion.div
              key={i}
              data-testid={`gallery-${i}`}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-8%" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              className={`group relative overflow-hidden ${SPANS[i] || "lg:col-span-4 aspect-[4/5]"}`}
            >
              <img
                src={src}
                alt={`Classroom ${i + 1}`}
                loading="lazy"
                className="h-full w-full object-cover grayscale group-hover:grayscale-0 scale-100 group-hover:scale-105 transition-[filter,transform] duration-700 ease-out"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-ink/10" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
